import TextArea, { type TextAreaProps } from "@common/controls/Inputs/TextArea/component";

import "./style.less";

export { type TextAreaProps };
export default TextArea;
